import type { ReactNode } from "react"

import Image from "next/image"

import { Stack, Text } from "@/components/ui"

interface CouponTicketProps {
  art: string
  children: ReactNode
  action: ReactNode
}

const notch = "border-line-sand absolute left-17.5 size-4.5 -translate-x-1/2 rounded-full border"

export const CouponTicket = ({ art, children, action }: CouponTicketProps) => (
  <div className="ticket-notched border-line-sand bg-surface rounded-7-5x relative flex border" data-testid="coupon-ticket">
    <span className={`${notch} top-0 -translate-y-1/2`} aria-hidden />
    <span className={`${notch} top-full -translate-y-1/2`} aria-hidden />
    <div className="border-line-sand my-250 flex w-17.5 shrink-0 items-center justify-center border-r border-dashed" aria-hidden>
      <Image src={art} alt="" width={40} height={40} />
    </div>
    <Stack gap="300" className="min-w-0 flex-1 px-400 py-400">
      <Text as="div" variant="body" family="text" tone="strong">
        {children}
      </Text>
      {action}
    </Stack>
  </div>
)
